import classNames from 'classnames'
import classNamesBind from 'classnames/bind'
import { Link } from 'gatsby'
import * as ProductStyles from '../../../styles/v1/product.module.scss'
import * as UtilsStyles from '../../../styles/v1/utils.module.scss'

const cx = classNamesBind.bind(ProductStyles, UtilsStyles)
const SubHeader = () => {
  const SubHeaderStyle = cx({
    productSubHeader: true,
    productSubHeaderScrollUp: true,
  })

  return (
    <div className={cx(SubHeaderStyle, UtilsStyles.isSp)}>
      <ul className={ProductStyles.productSubHeader_Inner}>
        <li className={ProductStyles.productSubHeader_Item}>
          <Link
            className={classNames(ProductStyles.productSubHeader_Link, 'trackBtn', 'js-anchor-link')}
            to="#benefit"
            data-category="sub-header"
            data-action="navigation"
            data-label="特徴"
          >
            特徴
          </Link>
        </li>
        <li className={ProductStyles.productSubHeader_Item}>
          <Link
            className={classNames(ProductStyles.productSubHeader_Link, 'trackBtn', 'js-anchor-link')}
            to="#interview"
            data-category="sub-header"
            data-action="navigation"
            data-label="お客様事例"
          >
            お客様事例
          </Link>
        </li>
        <li className={ProductStyles.productSubHeader_Item}>
          <Link
            className={classNames(ProductStyles.productSubHeader_Link, 'trackBtn', 'js-anchor-link')}
            to="#feature"
            data-category="sub-header"
            data-action="navigation"
            data-label="機能"
          >
            機能
          </Link>
        </li>
        <li className={ProductStyles.productSubHeader_Item}>
          <Link
            className={classNames(ProductStyles.productSubHeader_Link, 'trackBtn', 'js-anchor-link')}
            to="#contact"
            data-category="sub-header"
            data-action="navigation"
            data-label="お問い合わせ"
          >
            お問い合わせ
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default SubHeader
